export const pcbData = {
  surfaceFinish:["HASL (With Lead)","Lead Free HASL (ROHS)"],
  deliveryFormat:["Single PCB","Panel by Customer","Panel by Elecbits"],
  stencilRequired:["Yes","No"]
};
